import styles from "./ViewSwitcher.module.scss";

export type SearchViewMode = "grid" | "list";

interface ViewSwitcherProps {
  activeView: SearchViewMode;
  onChange: (view: SearchViewMode) => void;
}

const GridIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.25 2.25C1.83579 2.25 1.5 2.58579 1.5 3V7.5C1.5 7.91423 1.83579 8.25 2.25 8.25H7.5C7.91422 8.25 8.25 7.91423 8.25 7.5V3C8.25 2.58579 7.91422 2.25 7.5 2.25H2.25ZM3 6.75V3.75H6.75V6.75H3ZM2.25 9.75C1.83579 9.75 1.5 10.0858 1.5 10.5V15C1.5 15.4142 1.83579 15.75 2.25 15.75H7.5C7.91422 15.75 8.25 15.4142 8.25 15V10.5C8.25 10.0858 7.91422 9.75 7.5 9.75H2.25ZM3 14.25V11.25H6.75V14.25H3ZM9.75 3C9.75 2.58579 10.0858 2.25 10.5 2.25H15.75C16.1642 2.25 16.5 2.58579 16.5 3V7.5C16.5 7.91423 16.1642 8.25 15.75 8.25H10.5C10.0858 8.25 9.75 7.91423 9.75 7.5V3ZM11.25 3.75V6.75H15V3.75H11.25ZM10.5 9.75C10.0858 9.75 9.75 10.0858 9.75 10.5V15C9.75 15.4142 10.0858 15.75 10.5 15.75H15.75C16.1642 15.75 16.5 15.4142 16.5 15V10.5C16.5 10.0858 16.1642 9.75 15.75 9.75H10.5ZM11.25 14.25V11.25H15V14.25H11.25Z"
      fill="currentColor"
    />
  </svg>
);

const ListIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.5 3C1.5 2.58579 1.83579 2.25 2.25 2.25H15.75C16.1642 2.25 16.5 2.58579 16.5 3V15C16.5 15.4142 16.1642 15.75 15.75 15.75H2.25C1.83579 15.75 1.5 15.4142 1.5 15V3ZM12 14.25H15V3.75H12V14.25ZM10.5 3.75H7.5V14.25H10.5V3.75ZM3 3.75V14.25H6V3.75H3Z"
      fill="currentColor"
    />
  </svg>
);

const ViewSwitcher = ({ activeView, onChange }: ViewSwitcherProps) => {
  return (
    <div className={styles.switcherWrapper}>
      <button
        type="button"
        aria-label="List view"
        aria-pressed={activeView === "list"}
        className={`${styles.switcherButton} ${activeView === "list" ? styles.switcherButtonActive : ""}`}
        onClick={() => onChange("list")}
      >
        <GridIcon />
      </button>
      <button
        type="button"
        aria-label="Grid view"
        aria-pressed={activeView === "grid"}
        className={`${styles.switcherButton} ${activeView === "grid" ? styles.switcherButtonActive : ""}`}
        onClick={() => onChange("grid")}
      >
        <ListIcon />
      </button>
    </div>
  );
};

export default ViewSwitcher;
